import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { Link } from "react-router-dom";
import { SimpleLoading, PromotionalFooterPure } from "../../pures";
import ConfigurationSignatureHistoryPanelPure from "../../pures/configuration-signature-history-panel/configuration-signature-history-panel.pure";
import "./configuration-signature-history.css";

const ConfigurationSignatureHistoryView = (props) => {
  const { t } = useTranslation();
  let edit = t("configurationSignatureHistoryView.buttonDetail");

  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    boxShadow: "1px 1px 3px #959595",
    width: "auto",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  useEffect(() => {
    if (props.historyOfPlansItem)
      props.getHistoryOfPlansItem(props.historyOfPlansItem);
  }, []);

  return (
    <div className="configurationSignatureHistoryView-body">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="configurationSignatureHistoryView-container"
          >
            <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="configurationSignatureHistoryView-header"
              >
                <div className="configurationSignatureHistoryView-signature-ad">
                  <h3 className="configurationSignatureHistoryView-subtitle">
                    {t("configurationSignatureHistoryView.titleCreditsHistory")}
                  </h3>
                </div>
              </Grid>
              <Grid
                container
                className=" configurationSignatureHistoryView-signature"
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
              >
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="configurationSignatureHistoryView-tableHeaders"
                >
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                    <ConfigurationSignatureHistoryPanelPure
                      {...props}
                      edit={props.edit}
                      seeDetail={edit}
                      view={"index"}
                      onFilterContracts={props.onFilterContracts}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="configurationSignatureHistoryView-container-back"
                >
                  <Link
                    to={
                      props.contractSendByProps
                        ? "/configuration-contracts-history"
                        : "/configuration"
                    }
                    className="configurationSignatureHistoryView-link"
                  >
                    <button
                      onClick={props.scrollWindow}
                      className="configurationSignatureHistoryView-button-back"
                    >
                      {t("configurationPanelView.buttonBack")}
                    </button>
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  className="configurationSignatureHistoryView-tableHeaders"
                >
                  <PromotionalFooterPure />
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Container>
      )}
    </div>
  );
};

export { ConfigurationSignatureHistoryView as default };
